export const GET_AUTH_UPDATE_IMPORT_TEMPLATES_REQUEST = 'GET_AUTH_UPDATE_IMPORT_TEMPLATES_REQUEST';
export const GET_AUTH_UPDATE_IMPORT_TEMPLATES_SUCCESS = 'GET_AUTH_UPDATE_IMPORT_TEMPLATES_SUCCESS';
export const GET_AUTH_UPDATE_IMPORT_TEMPLATES_FAILURE = 'GET_AUTH_UPDATE_IMPORT_TEMPLATES_FAILURE';

export const GET_AUTH_UPDATE_IMPORT_TEMPLATE_REQUEST = 'GET_AUTH_UPDATE_IMPORT_TEMPLATE_REQUEST';
export const GET_AUTH_UPDATE_IMPORT_TEMPLATE_SUCCESS = 'GET_AUTH_UPDATE_IMPORT_TEMPLATE_SUCCESS';
export const GET_AUTH_UPDATE_IMPORT_TEMPLATE_FAILURE = 'GET_AUTH_UPDATE_IMPORT_TEMPLATE_FAILURE';

export const POST_AUTH_UPDATE_IMPORT_TEMPLATE_REQUEST = 'POST_AUTH_UPDATE_IMPORT_TEMPLATE_REQUEST';
export const POST_AUTH_UPDATE_IMPORT_TEMPLATE_SUCCESS = 'POST_AUTH_UPDATE_IMPORT_TEMPLATE_SUCCESS';
export const POST_AUTH_UPDATE_IMPORT_TEMPLATE_FAILURE = 'POST_AUTH_UPDATE_IMPORT_TEMPLATE_FAILURE';

export const PUT_AUTH_UPDATE_IMPORT_TEMPLATE_REQUEST = 'PUT_AUTH_UPDATE_IMPORT_TEMPLATE_REQUEST';
export const PUT_AUTH_UPDATE_IMPORT_TEMPLATE_SUCCESS = 'PUT_AUTH_UPDATE_IMPORT_TEMPLATE_SUCCESS';
export const PUT_AUTH_UPDATE_IMPORT_TEMPLATE_FAILURE = 'PUT_AUTH_UPDATE_IMPORT_TEMPLATE_FAILURE';

export const POST_AUTH_UPDATE_IMPORT_TEMPLATE_DRYRUN_REQUEST = 'POST_AUTH_UPDATE_IMPORT_TEMPLATE_DRYRUN_REQUEST';
export const POST_AUTH_UPDATE_IMPORT_TEMPLATE_DRYRUN_SUCCESS = 'POST_AUTH_UPDATE_IMPORT_TEMPLATE_DRYRUN_SUCCESS';
export const POST_AUTH_UPDATE_IMPORT_TEMPLATE_DRYRUN_FAILURE = 'POST_AUTH_UPDATE_IMPORT_TEMPLATE_DRYRUN_FAILURE';

export const POST_AUTH_UPDATE_IMPORT_TEMPLATE_SUBMIT_REQUEST = 'POST_AUTH_UPDATE_IMPORT_TEMPLATE_SUBMIT_REQUEST';
export const POST_AUTH_UPDATE_IMPORT_TEMPLATE_SUBMIT_SUCCESS = 'POST_AUTH_UPDATE_IMPORT_TEMPLATE_SUBMIT_SUCCESS';
export const POST_AUTH_UPDATE_IMPORT_TEMPLATE_SUBMIT_FAILURE = 'POST_AUTH_UPDATE_IMPORT_TEMPLATE_SUBMIT_FAILURE';

export const GET_AUTH_UPDATE_IMPORT_CLIENT_CUSTOM_FIELDS_REQUEST = 'GET_AUTH_UPDATE_IMPORT_CLIENT_CUSTOM_FIELDS_REQUEST';
export const GET_AUTH_UPDATE_IMPORT_CLIENT_CUSTOM_FIELDS_SUCCESS = 'GET_AUTH_UPDATE_IMPORT_CLIENT_CUSTOM_FIELDS_SUCCESS';
export const GET_AUTH_UPDATE_IMPORT_CLIENT_CUSTOM_FIELDS_FAILURE = 'GET_AUTH_UPDATE_IMPORT_CLIENT_CUSTOM_FIELDS_FAILURE';
